import React, { useState } from 'react'
import BasicDetails from './BasicDetails'
import AddressDetails from './AddressDetails'
import BankDetails from './BankDetails'
import PayoutDetails from './PayoutDetails'
import DealerBreconfig from './DealerBreConfig'
import Documents from './Dcouments'
export default function Main({ handlePage, Detaildata }) {
    const [tab, setTab] = useState("basic")
    // const [tab, setTab] = useState("breconfig")
    const [communityId, setcommunityId] = useState("")

    const handleTabs = (type) => {
        setTab(type)
    }

    const commId =(id)=>{
        setcommunityId(id)
    }

    return (
        <>
            {
                tab === "basic" ?
                    <BasicDetails handleTabs={handleTabs} handlePage={handlePage} commId={commId} Detaildata={Detaildata}/>
                    : ''}
            {
                tab === "address" ?
                    <AddressDetails handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} Detaildata={Detaildata}/>
                    : ''}
            {
                tab === "bank" ?
                    <BankDetails handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} Detaildata={Detaildata}/>
                    : ''}
            {
                tab === "payout" ?
                    <PayoutDetails handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} Detaildata={Detaildata}/>
                    : ''}
            {
                tab === "breconfig" ?
                    <DealerBreconfig handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} Detaildata={Detaildata}/>
                    : ''}
            {
                tab === "documents" ?
                    <Documents handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} />
                    : ''}
        </>
    )
}
